import DOMPurify from 'dompurify'

/**
 * Force safe attributes on all links added via WYSIWYG and printed via dangerouslySetInnerHTML
 * Prevents reverse tabnabbing / opener attacks
 */
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.hasAttribute('target')) {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

/**
 * Sanitize HTML from Confluence and WordPress using the DOMPurify library
 * Prevents XSS
 */
export function sanitizeHtml(html?: string) {
    return {
        __html: DOMPurify.sanitize(html ?? '', {
            ADD_ATTR: ['target'],
        }),
    };
}

/**
 * By default, all labels from Confluence API are lowercase and
 * have - for spaces. This function formats labels with title case
 * and converts the - to spaces.
 */
export function formatLabel(label: string): string {
    return label
        .replace(/[-_]/g, ' ')
        .replace(
            /\w\S*/g,
            (word) =>
                word.charAt(0).toUpperCase() +
                word.slice(1).toLowerCase()
        )
}

const CONFLUENCE_PAGE_ID_RE = /\/pages\/(\d+)(?:\/|$|\?)/

/**
 * Extract a Confluence page ID from a link href so in-body links to other
 * policy pages can be routed through TanStack Router instead of triggering a
 * full page load. Handles both relative and absolute URLs, e.g.
 * "/wiki/spaces/PolicyCatalog/pages/42106919/Private+Test".
 */
export function getConfluencePageId(href?: string): string | null {
    if (!href) return null

    try {
        const pathname = new URL(href, window.location.origin).pathname
        const match = pathname.match(CONFLUENCE_PAGE_ID_RE)
        return match?.[1] ?? null
    } catch {
        return null
    }
}
